<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
  import { cookies } from '@/util/cookies'
  export default {
    name: 'App',
    metaInfo: {
      title: 'Bodyswaps Go',
      meta: [
        { name: 'robots', content: 'noindex,nofollow' },
      ],
    },
    beforeMount () {
      const url = (window.location.href)
      let setBase = ''
      if (url.includes('baseUrl')) {
        const split = url.split('baseUrl=')
        if (split[1].includes('&')) {
          const base = split[1].split('&')
          setBase = base[0]
        } else {
          setBase = split[1]
        }
        setBase = decodeURIComponent(setBase) // <-- decode here
      }
      if (setBase) {
        if (setBase.includes('#/')) {
          setBase = setBase.slice(0, -2)
        }
        if (setBase.includes('#')) {
          setBase = setBase.slice(0, -1)
        }
        cookies.set('baseUrl', setBase)
      }
      // cookies.set('baseUrl', url)
    },
  }
</script>

<style lang="scss">
// @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap');
</style>
